/*
 * Component that behaves like an "intertitle", i.e. a screen with a title that describes the next "scene".
 * If you need to concat more than one, use the duration (ex: 2secs for the first and 4secs for the second one in order to see 2secs and 2secs).
 */
import React, { PureComponent } from 'react'
import { string, number } from 'prop-types'
import { Text } from 'components'
import defaultImage from 'assets/images/car.svg'
import startImage from 'assets/images/flag-start.svg'
import finishImage from 'assets/images/flag-finish.svg'

import './InterTitle.css'

export class InterTitle extends PureComponent {
    static propTypes = {
        image: string,
        title: string,
        text: string,
        duration: number
    }
    static defaultProps = {
        image: 'car',
        duration: 2000
    }

    state = {
        show: true
    }
    componentWillMount() {
        const { image, duration } = this.props
        setTimeout(this.hide, duration)
        this.image = defaultImage
        if (image === 'start') this.image = startImage
        if (image === 'finish') this.image = finishImage
    }
    hide = () => this.setState({ show: false })

    render() {
        const { image, title, text, className, ...otherProps } = this.props
        const { show } = this.state
        return (
            <div className={['InterTitle darkmode-background flex col-center', { Show: show }, className]} onClick={this.hide} {...otherProps}>
                <img src={this.image} />
                {title && <Text className="InterTitle-Title">{title}</Text>}
                {text && <Text className="InterTitle-Text">{text}</Text>}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/InterTitle/InterTitle.js